import { schema } from 'normalizr'
import { EmptyObject } from "../Resources/EmptyDefaults.js"

export const CALENDLY_LINK = 'calendlyLink'

export const calendlyLinkSchema = new schema.Entity(
  CALENDLY_LINK, EmptyObject, { idAttribute: () => 'data' }
)
